"use client";

import styled from "styled-components";

import Image from "../image";

interface BoxAlertProductProps {
  $isLowStock?: boolean;
}

export const CardProduct = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  border: 1px solid var(--border);
  border-radius: 8px;
  transition: 0.4s;
  width: 100%;
  max-width: 100%;
  min-width: 100%;

  &:hover {
    box-shadow: var(--shadowHoverCard);
  }
`;

export const HeaderCard = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
`;

export const BoxImage = styled.div`
  width: 100%;
  height: 130px;
  background: var(--backgroundColorSecondary, #f4f4f4);
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

export const ImageComponent = styled(Image)`
  border-radius: 15px 15px 0 0;
`;

export const BoxContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  padding: 15px;
  width: 100%;
`;

export const ImgWrapper = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 8px;
  overflow: hidden;
  background: var(--backgroundColorSecondary, #f2f2f2);
  flex-shrink: 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

export const FirstBox = styled.div`
  display: flex;
  align-items: start;
  gap: 8px;
  max-width: calc(100% - 71px);
`;

export const LastBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  flex-wrap: nowrap;
`;

export const BoxAlertProduct = styled.div<BoxAlertProductProps>`
  font-size: 0.875rem;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 50px;
  background-color: ${({ $isLowStock }) =>
    $isLowStock ? "#ffe5e5" : `var(--primarySystem)`};
  color: ${({ $isLowStock }) =>
    $isLowStock ? "#ff4d4f" : `var(--primarySystem100)`};
`;

export const BoxIcon = styled.div`
  background: var(--primarySystem);
  border-radius: 5px;
  padding: 5px;
  svg {
    width: 18px;
    height: 18px;
    path {
      stroke: var(--primarySystem100);
    }
    circle {
      stroke: var(--primarySystem100);
    }
  }
`;

export const TitleCard = styled.h3`
  font-family: "Inter Medium";
  font-size: 16px;
  color: var(--colorTitle);
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

export const BodyCard = styled.div`
  width: 100%;
  text-align: left;
`;

export const FooterCard = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-top: 1px solid var(--border);
  padding-top: 10px;
`;

export const TextDescription = styled.p`
  font-family: "Inter Regular";
  color: var(--textLight);
  font-size: 15px;
`;

export const Value = styled.span`
  font-family: "Inter Medium";
  font-size: 18px;
`;

export const Time = styled.span`
  display: block;
  font-family: "Inter Regular";
  font-size: 14px;
  padding: 5px 10px;
  border-radius: 50px;
  background: var(--backgroundColor);
`;

export const ListInfoProduct = styled.ul`
  padding: 0;
`;

export const ItemList = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  font-family: "Inter Medium";
  font-size: 15px;
`;

export const TitleInfo = styled.span`
  color: var(--textLight);
`;

export const Description = styled.span`
  color: var(--colorTitle);
`;
